import React from "react";

import CardComponent from "./Card"
import CardPaginator from "~/components/paginator"
import Cashback     from '~/services/cashbacks';

const ProgramsPaginator = ({setSelectedProgram, setOverlayOpen})=> {
  return (
      <CardPaginator endpoint={Cashback.paginators.all} card={CardComponent} options={{setSelectedProgram, setOverlayOpen}} />
  );
}

export default ProgramsPaginator;

